import { CustomApiExceptionType } from '@/modules/core/app/enums/CustomApiExceptionType';
import { DomainSsoExistsException } from '@/modules/user/models/exceptions/DomainSsoExistsException';
import { InvalidCompanyDomainException } from '@/modules/company/models/exceptions/InvalidCompanyDomainException';
import { SsoNotConfiguredException } from '@/modules/user/models/exceptions/SsoNotConfiguredException';
import { CustomApiException } from '@/modules/core/app/models/CustomApiException';

export class CustomApiExceptionFactory {
  static build(model: Partial<CustomApiException> | undefined): CustomApiException {
    switch (model?.exceptionType) {
      case CustomApiExceptionType.DOMAIN_SSO_EXISTS_EXCEPTION:
        return new DomainSsoExistsException(model);
      case CustomApiExceptionType.INVALID_COMPANY_DOMAIN_EXCEPTION:
        return new InvalidCompanyDomainException(model);
      case CustomApiExceptionType.SSO_NOT_CONFIGURED_EXCEPTION:
        return new SsoNotConfiguredException(model);
      default:
        return new CustomApiException(model);
    }
  }
}
